'use client';

import { useEffect } from 'react';
import { signIn, useSession } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';

export const Content = () => {
  const router = useRouter();
  const { status, data } = useSession();
  const searchParams = useSearchParams();

  useEffect(() => {
    const callbackUrl = searchParams.get('callbackUrl');

    if (
      status === 'unauthenticated' ||
      data?.error === 'RefreshAccessTokenError'
    ) {
      signIn('azure-ad-b2c', { callbackUrl: callbackUrl ?? '' });
    } else if (status === 'authenticated') {
      router.push(callbackUrl ?? '/');
    }
  }, [status, data]);

  return <></>;
};
